import React from "react";
import "react-table-v6/react-table.css";
import {
  Icon,
  Modal,
  Dropdown,
  Label,
  Loader,
  Form,
  Grid,
  Input,
  Dimmer
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import ButtonHandler from "../ButtonHandler.jsx";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
  fetchDashboardData, fetchTemplates, downloadDisbursementReportAction,
  getDisbursementSummaryFormat, getDisbursementSummaryData,
  summaryFileUpload,
  bulkDownloadDistFiles
} from "../../actions/users_action";
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarDensitySelector } from "@mui/x-data-grid";
import config from "../../config.js";
import DataTable from "../ControlPanelComponents/DataTable.jsx";
import DataView from "./HFSDataView.jsx";
import DisbursementDataView from "./DisbursementDataView.jsx";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selection: [],
      pageSize: 15,
      master: [],
      templateId: '',
      templates: [],
      selectedTemplate: '',
      selectedDashboard: '',
      summaryFormat: '',
      hfsFormat:'',
      modalOpen: false,
      currentFile: {},
      fileName: '',
      disSummaryData: [],
      disHFSData:[],
      loaderStatus: false,
      summaryData: '',
      hfsData:'',
      disPendingData: [],
      disPivotData: [],
      disCorpData:[],
      disLatData:[],
      disOneOffData:[],
      disSubdPi:[],
      disInprogressData:[],
      disQPSData:[],
      disStatusData:[],
      selectedMonth:'',
      selectedYear:'',
      rolling_summary_url:'',
      selectedFile:''

    };
  }

  componentDidMount() {
    this.props.fetchTemplates({
      onSuccess: (res) => {
        this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'] })
        this.props.fetchDashboardData(res.templates[res.templates.length - 1]['_id'], {
          onSuccess: (res) => {
            this.setState({ master: res.dashboard })
          },
          onFailure: () => {

          }
        })
      },
      onFailure: () => {

      }
    })
  }

  dropDownTemplateOnChange = (e, data) => {

    console.log('dropDownTemplateOnChange - data', data)
    let templateId = ''
    let selectedTemplate = ''
    data.options.map((d) => {
      if (data.value == d.value) {
        console.log('dropDownTemplateOnChange - matched data', data)
        templateId = d.key
        selectedTemplate = data.value
      }
    })
    

    const str = selectedTemplate;

    const parts = str.split(" - ")[1]; 

    const [monthName, year] = parts.split(" ");

    const monthMap = {
      January: 0, February: 1, March: 2, April: 3,
      May: 4, June: 5, July: 6, August: 7,
      September: 8, October: 9, November: 10, December: 11
    };

    const month = monthMap[monthName];

    this.setState({ selectedTemplate: selectedTemplate, templateId: templateId,selectedMonth:month,selectedYear:parseInt(year) })
    console.log('dropDownTemplateOnChange - templateId', templateId)
    console.log('dropDownTemplateOnChange - selectedTemplate', selectedTemplate)

    this.props.fetchDashboardData(templateId, {
      onSuccess: (res) => {
        this.setState({ master: res.dashboard })
      },
      onFailure: () => {

      }
    })

    this.props.getDisbursementSummaryFormat(templateId,this.state.selectedDashboard, {
      onSuccess: (res) => {
        console.log('getDisbursementSummaryFormat - templateId', templateId)
        if(this.state.selectedDashboard == 'Pre-Disbursement Tracker'){
          if (res.summary_format !== '') {

            this.setState({ summaryFormat: res.summary_format })
            if (res.summary_data !== '') {
          
              this.setState({ summaryData: res.summary_data })
            }
            else {
          
              this.setState({ summaryData: '' })
            }
          }
          else {
            this.setState({ summaryFormat: '', summaryData: '' })
          }
        }
        else if(this.state.selectedDashboard == 'HFS Tracker'){
          if (res.hfs_format !== '') {
            this.setState({ hfsFormat: res.hfs_format })
            if (res.hfs_data !== '') {
    
              this.setState({ hfsData: res.hfs_data })
            }
            else {
        
              this.setState({ hfsData: '' })
            }
          }
          else {
            this.setState({ hfsFormat: '', hfsData: '' })
          }
        }
        
      },
      onFailure: () => {

      }
    })
    let sum_data = {
      templateId: templateId,
      role: 'admin',
      type:this.state.selectedDashboard
    }
    this.props.getDisbursementSummaryData(sum_data, {
      onSuccess: (res) => {
        console.log('getDisbursementSummaryData - sum_data', sum_data)
        console.log('type of res', typeof res)
        if (typeof res === 'string') {
          console.log("Response is string");
          console.log(res);

          try {
              res = JSON.parse(res);
              console.log("JSON parsed successfully");
          } catch (err) {
              console.error("JSON.parse failed");
              console.error(err);
              console.log("Actual response:", res);
              return;
          }
        }
        console.log('getDisbursementSummaryData res', res)
        console.log('selectedDashboard : ', this.state.selectedDashboard)
        if(this.state.selectedDashboard == 'Pre-Disbursement Tracker'){
          if (res.summary_data != undefined && res.summary_data.length > 0) {
            let corp = []
                let lat = []
                let oneOff = []
                let status = []
                let qps = []
                let pivot = []
                let count = 0
                console.log('res.summary_data-keys', Object.keys(res.summary_data))
                res.summary_data.forEach((d)=>{
                  if(d.types && d.types == 'Corporate'){
                    corp.push(d)
                  }
                  else if(d.types && d.types == 'LAT'){
                    lat.push(d)
                  }
                  else if(d.types && d.types == 'oneOff'){
                    oneOff.push(d)
                  }
                  else if(d.types && d.types == 'status') {
                    status.push(d);
                    
                    let found = pivot.find(p => p.Status === d.Status);
                    if (found) {
                      found["Program Name / Plans"] += 1;
                    } else {
                      count++;
                      pivot.push({
                        Status: d.Status,
                        "Program Name / Plans": 1,
                        "id": count
                      });
                    }
                  }
                  else if(d.types && d.types == 'qpsWorking'){
                    qps.push(d)
                  }
                })
            this.setState({ disSummaryData: [],disCorpData: corp,disLatData:lat,disOneOffData:oneOff,disQPSData:qps,disStatusData:status,disPivotData:pivot })
          }
          else {
            this.setState({ disSummaryData: [],disCorpData:[],disLatData:[],disOneOffData:[],disQPSData:[],disStatusData:[] })
          }
          if(res.rolling_summary_url && res.rolling_summary_url != ''){
            this.setState({rolling_summary_url:res.rolling_summary_url})
          }
           else{
              this.setState({rolling_summary_url:''})
            }
        }
        else if(this.state.selectedDashboard == 'HFS Tracker'){
          if (res.summary_data != undefined && res.summary_data.length > 0) {
            this.setState({ disHFSData: res.summary_data })
          }
          else {
            this.setState({ disHFSData: []})
          }
        }
      },
      onFailure: () => {

      }
    })
    // this.getMonthYear()
    console.log(this.state.summaryData, 'sum_bef')
  }

  dropDownDashboardOnChange = (e, data) => {
    this.setState({ selectedDashboard: data.value })
  }

  downloadTracker = () => {
    let templateId = this.state.templateId
    this.props.downloadDisbursementReportAction(templateId, {
      onSuccess: () => {

      },
      onFailure: () => {

      }
    })
  }

  buldDownload = () =>{
    let templateId = this.state.templateId
    let selectedFile = this.state.selectedFile
    this.setState({ loaderStatus: true })
    let data = {
      templateId:templateId,
      fileName:selectedFile
    }
    this.props.bulkDownloadDistFiles(data,{
      onSuccess:()=>{
        this.setState({ loaderStatus: false })
      },
      onFailure:()=>{
        this.setState({ loaderStatus: false })
        alert("Unable to Download. Please Contact Admin")
      }
    })

  }

  downloadSummaryFormat = () => {
    if (this.state.summaryFormat !== '') {
      window.open(this.state.summaryFormat);
    }
    else {
      alert("File Not Available")
    }
  }


  downloadHFSFormat = () => {
    if (this.state.hfsFormat !== '') {
      window.open(this.state.hfsFormat);
    }
    else {
      alert("File Not Available")
    }
  }

  downloadSummaryData = () => {
    if (this.state.summaryData !== '') {
      window.open(this.state.summaryData);
    }
    else {
      alert('File Not Available')
    }
  }

  downloadHFSData = () => {
    if (this.state.hfsData !== '') {
      window.open(this.state.hfsData);
    }
    else {
      alert('File Not Available')
    }
  }

  closeuploadoption = () => {
    this.setState({ modalOpen: false })
  }

  fileupload = (file) => {
    this.setState({ currentFile: file.target.files[0], fileUploaded: true })
  };

  uploadSummary = (fileName) => {
    this.setState({ loaderStatus: true })
    let file = this.state.currentFile
    let templateId = this.state.templateId
    this.props.summaryFileUpload(file, this.state.fileName, templateId, {
      onSuccess: () => {
        this.setState({ modalOpen: false, loaderStatus: false })
        let sum_data = {
          templateId: templateId,
          role: 'admin',
          type:this.state.selectedDashboard
        }
        this.props.getDisbursementSummaryData(sum_data, {
          onSuccess: (res) => {
            
            if(this.state.selectedDashboard == 'Pre-Disbursement Tracker'){
              if (res.summary_data != undefined && res.summary_data.length > 0) {
                let corp = []
                let lat = []
                let oneOff = []
                let qps = []
                let status = []
                let pivot = []
                let count = 0
                res.summary_data.forEach((d)=>{
                  if(d.types && d.types == 'Corporate'){
                    corp.push(d)
                  }
                  else if(d.types && d.types == 'LAT'){
                    lat.push(d)
                  }
                  else if(d.types && d.types == 'oneOff'){
                    oneOff.push(d)
                  }

                  else if(d.types && d.types == 'qpsWorking'){
                    qps.push(d)
                  }
                  else if(d.types && d.types == 'status') {
                    status.push(d);
                    
                    let found = pivot.find(p => p.Status === d.Status);
                    if (found) {
                      found["Program Name / Plans"] += 1;
                    } else {
                      count++;
                      pivot.push({
                        Status: d.Status,
                        "Program Name / Plans": 1,
                        "id": count
                      });
                    }
                  }
                })
                this.setState({ disSummaryData: [],disCorpData: corp,disLatData:lat,disOneOffData:oneOff,disQPSData:qps,disStatusData:status,disPivotData:pivot })
              }
              else {
                this.setState({ disSummaryData: [],disCorpData:[],disLatData:[],disOneOffData:[],disQPSData:[],disStatusData:[] })
              }
              if(res.rolling_summary_url && res.rolling_summary_url != ''){
              this.setState({rolling_summary_url:res.rolling_summary_url})
            }
            else{
              this.setState({rolling_summary_url:''})
            }
            }
            else if(this.state.selectedDashboard == 'HFS Tracker'){
              if (res.summary_data != undefined && res.summary_data.length > 0) {
                this.setState({ disHFSData: res.summary_data })
              }
              else {
                this.setState({ disHFSData: []})
              }
            }
            
          },
          onFailure: () => {

          }
        })

        alert("File Uploaded Successfully")
      },
      onFailure: () => {
        this.setState({ loaderStatus: false })
        alert("Unable to Upload. Please Contact Admin")
      }
    })
  }


  uploadFile = (fileName) => {
    this.setState({ fileName: fileName, modalOpen: true })
  }


  fileChoosen = (e, data) => {
    console.log(data.value,'datatata')
    this.setState({selectedFile:data.value})
  
  }
  render() {

    var templateMonths = []

    var fileList = []

    if(this.state.master.length){
       Object.keys(this.state.master[0]).forEach(key => {
        if (key !== "id" && key !== "distributor") {
          fileList.push({
            key: key,
            value: key,
            text: key
          });
        }
      });
    }
   

    // console.log('fileList', fileList);

    this.state.templates.map((d) => {
      templateMonths.push({
        'key': d._id,
        'value': d.name,
        'text': d.name
      })
    })

    var dashboardsList = [
      {
        'key': 'File Upload Tracker',
        'value': 'File Upload Tracker',
        'text': 'File Upload Tracker'
      },
      {
        'key': 'Pre-Disbursement Tracker',
        'value': 'Pre-Disbursement Tracker',
        'text': 'Pre-Disbursement Tracker'
      },
      {
        'key': 'HFS Tracker',
        'value': 'HFS Tracker',
        'text': 'HFS Tracker'
      },

    ]

    var HFSTeamList = [
      {
        'key': 'HFS Tracker',
        'value': 'HFS Tracker',
        'text': 'HFS Tracker'
      }
    ]

    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexFlow: "column",
          height: "86vh",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
         <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <Dimmer active={this.state.loaderStatus}>
                                <Loader size="massive">Loading.....</Loader>
                            </Dimmer>
                        </div>
        <div style={{ height: '100%', flex: 1 }} >

          <h1
            style={{

              flex: "0 0 30px",
              display: "inline-block",
              color: "#2185d0",
            }}
          >
            Disbursement Dashboard
          </h1>  
          {(this.props.auth.userName === 'Admin' || this.props.auth.userName === 'MatrixLogin') && 
            <Dropdown placeholder='Select Dashboard' search selection options={dashboardsList}
            onChange={this.dropDownDashboardOnChange}
            value={this.state.selectedDashboard}
            style={{ marginLeft: 40 }}

          />
          }
          {this.props.auth.userName === 'HFSTeam' &&
            <Dropdown placeholder='Select Dashboard' search selection options={HFSTeamList}
            onChange={this.dropDownDashboardOnChange}
            value={this.state.selectedDashboard}
            style={{ marginLeft: 40 }}

          />
          }
          
          <br />
          {this.state.selectedDashboard == 'File Upload Tracker' &&
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>

                <div>
                  <Dropdown placeholder='Select Month' search selection options={templateMonths}
                    onChange={this.dropDownTemplateOnChange}
                    value={this.state.selectedTemplate}

                  />
                </div>

                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={this.downloadTracker}
                  >
                    <Icon name="download" />
                    Download Tracker
                  </Label>
                </div>
                <div style={{marginLeft: 20,}}>
                  <Dropdown placeholder='Select File' search selection options={fileList}
                    onChange={this.fileChoosen}
                    value={this.state.selectedFile}

                  />
                </div>
                 <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={this.buldDownload}
                  >
                    <Icon name="download" />
                    Download Files as Zip
                  </Label>
                </div>
              </div>
              {this.state.master.length > 0 &&

                <DataTable title={''} data={this.state.master} type='fileUploadTracker' />

              }
            </div>
          }
          {this.state.selectedDashboard == 'Pre-Disbursement Tracker' &&
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>

                <div>
                  <Dropdown placeholder='Select Month' search selection options={templateMonths}
                    onChange={this.dropDownTemplateOnChange}
                    value={this.state.selectedTemplate}

                  />
                </div>
                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={this.downloadSummaryFormat}
                  >
                    <Icon name="download" />
                    Download Summary Format
                  </Label>
                </div>
                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={() => this.uploadFile('disbursementSummary')}
                  >
                    <Icon name="upload" />
                    Upload Summary Data
                  </Label>
                </div>
                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={this.downloadSummaryData}
                  >
                    <Icon name="download" />
                    Download Summary Data
                  </Label>
                </div>
                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={() => this.uploadFile('disbursementRollingSummary')}
                  >
                    <Icon name="upload" />
                    Upload Rolling Summary Data
                  </Label>
                </div>
              </div>
              <div>
                {/* {console.log(this.state.disPivotData,'disPivotData')} */}
                {(this.state.disCorpData.length > 0 || this.state.disLatData.length > 0 || this.state.disOneOffData.length > 0 || this.state.disQPSData.length > 0 || this.state.disStatusData.length > 0 || this.state.disPivotData.length > 0) &&
                  <div>
                    <br></br>
                    <h3>Overall Status</h3>
                    {console.log('disPivotData',this.state.disPivotData)}
                    <DisbursementDataView  data={this.state.disPivotData} types={'overall'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                    <br></br>
                    <h3>Disbursement Wise Status</h3>

                    {console.log('disStatusData',this.state.disStatusData)}
                    <DisbursementDataView  data={this.state.disStatusData} types={'status'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                    <br></br>

                    <h3>Corporate Status</h3>
                    {console.log('disCorpData',this.state.disCorpData)}
                    <DisbursementDataView  data={this.state.disCorpData} types={'corp'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                    <br></br>
                    
                    <h3>LAT Status</h3>
                    {console.log('disLatData',this.state.disLatData)}
                    <DisbursementDataView  data={this.state.disLatData} types={'lat'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                    <br></br>

                    <h3>OneOff Display Status</h3>
                    {console.log('disOneOffData',this.state.disOneOffData)}
                    <DisbursementDataView  data={this.state.disOneOffData} types={'oneoff'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                    <br></br>

                    <h3>QPS Status</h3>
                    {console.log('disQPSData',this.state.disQPSData)}
                    <DisbursementDataView  data={this.state.disQPSData} types={'qps'} templateMonth={this.state.selectedMonth} templateYear={this.state.selectedYear} rolling_summary_url={this.state.rolling_summary_url}/>
                    <br></br>
                    
                    
                  </div>

                }
              </div>
            </div>
          }
          {this.state.selectedDashboard == 'HFS Tracker' &&
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>

                <div>
                  <Dropdown placeholder='Select Month' search selection options={templateMonths}
                    onChange={this.dropDownTemplateOnChange}
                    value={this.state.selectedTemplate}

                  />
                </div>
                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={this.downloadHFSFormat}
                  >
                    <Icon name="download" />
                    Download HFS Format
                  </Label>
                </div>
                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={() => this.uploadFile('hfsSummary')}
                  >
                    <Icon name="upload" />
                    Upload HFS Data
                  </Label>
                </div>
                <div>
                  <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer", marginLeft: 20, marginTop: 5 }}
                    size="large"
                    color="blue"
                    onClick={this.downloadHFSData}
                  >
                    <Icon name="download" />
                    Download HFS Data
                  </Label>
                </div>
              </div>
              <div>
                {this.state.disHFSData.length > 0 &&
                  <div>
                    <br></br>
                    <br></br>
                    {/* <h3>SiteWise Status</h3> */}
                    {/* <DataTable title={''} data={this.state.disHFSData} type='hfsSummary' /> */}
                    <DataView data={this.state.disHFSData}/>
                    {/* <br></br>
                    <br></br> */}
                    {/* <h3>Rejection Breakup</h3> */}
                    {/* <DataTable title={''} data={this.state.disHFSData} type='hfsSummary' /> */}
                    {/* <DataView data={this.state.disHFSData} type = 'breakup'/> */}
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <Modal
          open={this.state.modalOpen}
          onClose={this.closeuploadoption}
          size="mini"
        >
          <Modal.Content>
            <Form>
              <Grid columns={1}>
                <Grid.Row>

                  <Grid.Column style={{ marginTop: 20 }}>
                    <h4>Upload Summary Sheet :</h4>
                    <Input
                      type="file"
                      accept=".xlsx"
                      onChange={this.fileupload}
                      multiple
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
              <ButtonHandler
                click={() => this.uploadSummary('disbursement_summary_data')}
                title={'Upload'}
                color={'green'}
                iconColor={'white'}
                disabled={this.state.fileUploaded ? false : true}
              />
              <ButtonHandler
                click={this.closeuploadoption}
                isIcon={true}
                color={'red'}
                iconName={'remove'}
                iconColor={'white'}
                title={'Close'}
              />
            </div>

          </Modal.Actions>
          {this.state.loaderStatus && (
            <Dimmer active inverted>
              <Loader inverted>Loading</Loader>
            </Dimmer>
          )}
        </Modal>

      </div>
    );
  }
}

function AuditTableCell(props) {
  function onClick() {
    props.onClick(props.row);
  }
  return (
    <div style={props.style} onClick={onClick}>
      {props.text}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchDashboardData,
      fetchTemplates,
      downloadDisbursementReportAction,
      getDisbursementSummaryFormat, getDisbursementSummaryData,
      summaryFileUpload,
      bulkDownloadDistFiles
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
